<template>
	<EventLayout :event="event" :subtitle="bundle.title" :return-url="route('events.bundles.index', event.id)" :return-label="trans('events.bundles.title')">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="save">
				<i class="fa-solid fa-save mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
		</template>
		<div class="flex items-end gap-3">
			<LabeledObject required full>
				<template #label>{{ trans('general.title') }}</template>
				<input v-model="bundle.title" type="text">
			</LabeledObject>
			<Switch v-model.number="bundle.active" :label="trans('general.enabled')" full/>
		</div>
		<LabeledObject>
			<template #label>{{ trans('general.description') }}</template>
			<TextEditor v-model="bundle.description" bordered/>
		</LabeledObject>
		<ManageOffers :event="event" :bundle="bundle" :offers="bundle.offers"/>
	</EventLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, ref, type Ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import EventLayout from '@/Layouts/EventLayout.vue'
import Switch from '@/Components/UI/Switches/Switch.vue'
import {type Bundle} from '@/Types/Events/Bundles/Bundle'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import TextEditor from '@/Components/UI/Editor/TextEditor.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import ManageOffers from '@/Components/Events/Bundles/Offers/ManageOffers.vue'

const props = defineProps<{
	bundle:Bundle,
	event:Event,
}>()

const bundle:Ref<Bundle> = ref(props.bundle)
const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)

function save():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.bundles.update', {
			event: event.value.id,
			bundle: bundle.value.id,
		}), bundle.value).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>